/** Web stub: no native ad SDK on the showcase, so the banner renders nothing. */
export function AdBanner() {
  return null;
}
